module.exports = __webpack_public_path__ + "img/csv-icon.c612f2e5.svg";